function registerInClinicGiftCardWizard() {
  if (!window.Alpine || window.__inClinicGiftCardWizardRegistered) return;

  window.__inClinicGiftCardWizardRegistered = true;

  window.Alpine.data('inClinicGiftCardWizard', (config = {}) => ({
    step: 1,
    error: '',
    minDate: config.minDate || '',

    recipientType: 'A Friend',

    recipientFirstName: '',
    recipientLastName: '',
    recipientEmail: '',
    recipientPhone: '',

    senderFirstName: '',
    senderLastName: '',
    senderEmail: '',
    senderPhone: '',

    buyerFirstName: '',
    buyerLastName: '',
    buyerEmail: '',
    buyerPhone: '',

    message: '',
    confirmEmail: '',
    deliveryDate: '',
    quantity: 1,

    selectedVariantId: String(config.initialVariantId || ''),
    selectedVariantTitle: config.initialVariantTitle || '',
    selectedVariantPrice: config.initialVariantPrice || '',
    selectedDesignLabel: config.initialDesignLabel || '',
    selectedDesignImage: config.initialDesignImage || '',

    get emailLabel() {
      if (this.recipientType === 'A Friend') {
        return this.recipientFirstName
          ? `${this.recipientFirstName}'s email`
          : 'Recipient email';
      }

      return 'Your email';
    },

    goTo(stepNumber) {
      this.error = '';
      this.step = stepNumber;
    },

    nextFromStep1() {
      this.error = '';

      if (this.recipientType === 'A Friend') {
        if (!this.recipientFirstName.trim()) {
          this.error = 'Please enter the recipient first name.';
          return;
        }

        if (!this.recipientLastName.trim()) {
          this.error = 'Please enter the recipient last name.';
          return;
        }

        if (!this.recipientEmail.trim()) {
          this.error = 'Please enter the recipient email.';
          return;
        }

        if (!this.isValidEmail(this.recipientEmail.trim())) {
          this.error = 'Please enter a valid recipient email.';
          return;
        }

        if (!this.recipientPhone.trim()) {
          this.error = 'Please enter the recipient phone number.';
          return;
        }

        if (!this.senderFirstName.trim()) {
          this.error = 'Please enter your first name.';
          return;
        }

        if (!this.senderLastName.trim()) {
          this.error = 'Please enter your last name.';
          return;
        }

        if (!this.senderEmail.trim()) {
          this.error = 'Please enter your email.';
          return;
        }

        if (!this.isValidEmail(this.senderEmail.trim())) {
          this.error = 'Please enter a valid email.';
          return;
        }

        if (!this.senderPhone.trim()) {
          this.error = 'Please enter your phone number.';
          return;
        }
      }

      if (this.recipientType === 'For Me') {
        if (!this.buyerFirstName.trim()) {
          this.error = 'Please enter your first name.';
          return;
        }

        if (!this.buyerLastName.trim()) {
          this.error = 'Please enter your last name.';
          return;
        }

        if (!this.buyerEmail.trim()) {
          this.error = 'Please enter your email.';
          return;
        }

        if (!this.isValidEmail(this.buyerEmail.trim())) {
          this.error = 'Please enter a valid email.';
          return;
        }

        if (!this.buyerPhone.trim()) {
          this.error = 'Please enter your phone number.';
          return;
        }
      }

      this.step = 2;
    },

    nextFromStep2() {
      this.error = '';

      if (!this.selectedDesignLabel) {
        this.error = 'Please choose a gift card design.';
        return;
      }

      this.step = 3;
    },

    nextFromStep3() {
      this.error = '';

      if (!this.selectedVariantId) {
        this.error = 'Please choose an amount.';
        return;
      }

      if (this.quantity < 1) {
        this.error = 'Quantity must be at least 1.';
        return;
      }

      this.step = 4;
    },

    selectDesign(label, image) {
      this.selectedDesignLabel = label;
      this.selectedDesignImage = image;
      this.error = '';
    },

    selectVariant(id, title, price) {
      this.selectedVariantId = String(id);
      this.selectedVariantTitle = title;
      this.selectedVariantPrice = price;
      this.error = '';
    },

    increaseQty() {
      this.quantity += 1;
      this.error = '';
    },

    decreaseQty() {
      if (this.quantity > 1) {
        this.quantity -= 1;
      }
      this.error = '';
    },

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    validateAndSubmit(event) {
      this.error = '';

      if (this.deliveryDate && this.minDate && this.deliveryDate < this.minDate) {
        this.error = 'Delivery date cannot be in the past.';
        event.preventDefault();
      }
    }
  }));

  const roots = document.querySelectorAll('[x-data*="inClinicGiftCardWizard"]');
  roots.forEach((root) => {
    if (!root.__icgcInitialized) {
      root.__icgcInitialized = true;
      window.Alpine.initTree(root);
    }
  });
}

if (window.Alpine) {
  registerInClinicGiftCardWizard();
} else {
  document.addEventListener('alpine:init', registerInClinicGiftCardWizard);
}